import React from 'react'
import { SEO } from '../../../../components/Seo/seo'
import { useParams } from 'react-router-dom'
import { payments } from '../../../../utils/pages-meta'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import NoMatch from '../../../NoMatch'
import PaymentReceiptsContent from '../../../../components/Workspace/CompanyPage/PaymentReceiptsContent'
import { FormattedMessage, useIntl } from 'react-intl'
import { SearchLoader } from '../../../../components/Loader/SearchLoader'
import InActiveUserContent from '../../../../components/InActiveUserContent'
import { Container } from '@material-ui/core'
import { useStyles } from '../Styles'

const PaymentReceipts = () => {
  let { id } = useParams()
  const intl = useIntl()
  const classes = useStyles()
  return (
    <>
      {!!id && !!parseInt(id) ? <>
          <SEO title={intl.formatMessage({ id: 'PageTitle.PaymentReceipts' })}
               pathname={window.location.origin}
               titleTemplate={intl.formatMessage({ id: 'E-Tax-Workspace' })}
               image={payments.image}
               description={intl.formatMessage({ id: 'PageTitle.PaymentReceipts' })}
          />
          <AuthenticatedUserConsumer>
            {({ userDataLoading, isUserActive, userData, checkCompanyData }) => (
              <>
                <Container maxWidth="lg" className={classes.TitleContainer}>
                  <h1><FormattedMessage id='PageTitle.PaymentReceipts'/></h1>
                </Container>
                {!!userDataLoading && <SearchLoader loading={true}/>}
                {(!!Object.keys(userData).length && !!isUserActive) ?
                  <PaymentReceiptsContent checkCompanyData={checkCompanyData} cid={id}/>
                  : (!userDataLoading && <InActiveUserContent/>)
                }
              </>
            )}
          </AuthenticatedUserConsumer>
        </> :
        <NoMatch/>
      }
    </>
  )
}

export default PaymentReceipts
